import { AppBar, Box, Button, Toolbar, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import CostlixLogo from "../../assets/images/logoT.png";

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 8);
    };

    handleScroll(); // run once on mount
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // useEffect(() => {
  //   const hero = document.getElementById("hero");
  //   if (!hero) return;

  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       setScrolled(!entry.isIntersecting);
  //     },
  //     {
  //       root: null,
  //       threshold: 0,
  //       rootMargin: "-80px 0px 0px 0px", // header height
  //     },
  //   );

  //   observer.observe(hero);
  //   return () => observer.disconnect();
  // }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const talkToExpert = () => {
    const phone = "919532119007"; // no + sign
    const message = "Hello Costlix, I want to talk to an cost expert.";
    const encodedMessage = encodeURIComponent(message);

    window.open(`https://wa.me/${phone}?text=${encodedMessage}`, "_blank");
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,

        backgroundColor: scrolled ? "rgba(246,247,235,0.9)" : "transparent",

        backdropFilter: scrolled ? "blur(14px)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(14px)" : "none",

        borderBottom: scrolled ? "1px solid var(--color-midnight-15)" : "none",

        boxShadow: scrolled ? "0 10px 30px rgba(0,0,0,0.14)" : "none",

        transition: "all 0.3s ease",

        /* prevents hero bleed */
        // "&::after": scrolled
        //   ? {
        //       content: '""',
        //       position: "absolute",
        //       left: 0,
        //       right: 0,
        //       bottom: -24,
        //       height: 24,
        //       background:
        //         "linear-gradient(180deg, rgba(246,247,235,0.9) 0%, rgba(246,247,235,0) 100%)",
        //       pointerEvents: "none",
        //     }
        //   : {},
      }}
    >
      <Toolbar
        sx={{
          maxWidth: 1240,
          width: "100%",
          mx: "auto",
          minHeight: { xs: 64, md: 76 },
          px: { xs: 2, md: 3 },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* LEFT: Brand + Product Badge */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            alignItems: "flex-start",
          }}
        >
          <img src={CostlixLogo} alt="Costlix" height={isMobile ? 34 : 42} />

          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                mt: "2px",
              }}
            >
              <Box
                sx={{
                  px: 1.4,
                  py: 0.35,
                  borderRadius: 999,
                  fontSize: "0.72rem",
                  fontWeight: 600,
                  backgroundColor: "var(--color-midnight-15)", // ✅ ONLY YOUR COLOR
                  color: "var(--color-midnight)",
                  whiteSpace: "nowrap",
                  lineHeight: 1.2,
                }}
              >
                Website & App Cost Estimator
              </Box>
            </Box>
          )}
        </Box>

        {/* RIGHT: Mobile / Desktop Actions */}
        {isMobile ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* How it works */}
            <Box
              onClick={() => scrollTo("how-it-works")}
              role="button"
              aria-label="How it works"
              sx={{
                minHeight: 32,
                px: 1.6,
                py: 0.6,
                borderRadius: 999,
                fontSize: "0.8rem",
                fontWeight: 600,
                cursor: "pointer",
                border: "1px solid var(--color-midnight-15)", // ✅
                color: "var(--color-midnight)",
                backgroundColor: "transparent",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
              }}
            >
              How it works
            </Box>

            {/* No Signup */}
            <Box
              aria-label="No signup required"
              sx={{
                minHeight: 32,
                px: 1.6,
                py: 0.6,
                borderRadius: 999,
                fontSize: "0.8rem",
                fontWeight: 600,
                backgroundColor: "var(--color-midnight-15)", // ✅
                color: "var(--color-midnight)",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
              }}
            >
              ✓ No Signup
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
            <Button
              variant="text"
              onClick={() => scrollTo("how-it-works")}
              sx={{ fontWeight: 500 }}
            >
              How it works
            </Button>
            {/* <Button
              variant="outlined"
              size="small"
              sx={{
                height: 38,
                px: 2,
                fontSize: "0.85rem",
                borderRadius: "10px",
              }}
            >
              Talk to Expert
            </Button>

            <Button
              onClick={() => scrollTo("estimator")}
              variant="contained"
              color="secondary"
              size="small"
              sx={{
                height: 38,
                px: 2.5,
                fontSize: "0.85rem",
                borderRadius: "10px",
                boxShadow: "none", // important
              }}
            >
              Get Estimate
            </Button> */}

            <Button onClick={() => talkToExpert()} variant="outlined">
              Talk to Expert
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={() => scrollTo("estimator")}
            >
              Get Estimate
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
